import { render, staticRenderFns } from "./SkillsView.vue?vue&type=template&id=8d8150ee&scoped=true&"
import script from "./SkillsView.vue?vue&type=script&lang=js&"
export * from "./SkillsView.vue?vue&type=script&lang=js&"
import style0 from "./SkillsView.vue?vue&type=style&index=0&id=8d8150ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8150ee",
  null
  
)

export default component.exports